export default loanAmountConfig => {
	const hasMinAmount = loanAmountConfig.minLoanAmount > 0;
	const hasMaxAmount = !!loanAmountConfig.maxLoanAmount;

	if (hasMinAmount) {
		const formattedMin = loanAmountConfig.minLoanAmount.toLocaleString('en-US');
		let placeholder = `$${formattedMin} min`;

		if (hasMaxAmount) {
			const formattedMax = loanAmountConfig.maxLoanAmount.toLocaleString('en-US');
			placeholder = `${placeholder} - $${formattedMax} max`;
		}

		return placeholder;
	}

	if (hasMaxAmount) {
		const formattedMax = loanAmountConfig.maxLoanAmount.toLocaleString('en-US');
		return `$${formattedMax} max`;
	}

	return '';
};
